<div>
  <app-svg-loader style="text-align: center" url="input-pin.svg" alt="Input PIN"></app-svg-loader>
  <div class="p-card-title">Enter PIN</div>
  <div class="p-card-subtitle">
    {{ subTitle() }}
  </div>
</div>

<div>
  <code-input
    #codeInput
    class="pin-input invalid"
    [isCodeHidden]="true"
    [codeLength]="6"
    [isCharsCode]="false"
    (codeChanged)="onCodeChanged($event)"
    [ngClass]="{
      invalid: error$(),
    }"
  >
  </code-input>
  <p class="warning-message" *ngIf="error$()">
    <i class="pi pi-exclamation-triangle"></i> {{ error$() }}
  </p>
</div>

<div style="gap: 16px; display: flex; flex-direction: column">
  <div class="forgot-pin">
    <a href="/account-setting">Forgot PIN?</a>
  </div>
  <div style="display: flex; gap: 16px; margin: 0 auto">
    <lib-button [type]="'Secondary'" [widthFull]="true" (click)="cancel()" width="120px"
      >Cancel</lib-button
    >
    <lib-button [widthFull]="true" (click)="next()" width="120px">Next</lib-button>
  </div>
</div>

<app-block-loading *ngIf="isLoading()" [show]="isLoading()"></app-block-loading>
